import { GlobalFilterObject } from '@type/filters';
import { ISearchFiltersObject } from './searchFiltersObject';

export const mapSearchFilterToGlobalFilter: (filter: ISearchFiltersObject, groupType: string) => GlobalFilterObject = (filter, groupType) => ({
  groupType,
  apiParameter: filter.apiParameter,
  fields: filter.fields.map((field) => ({
    recordOptions: {
      ...field,
      // Propagate valueAsArray from the parent filter so single-item selections
      // are stored as arrays — without this, string '9' instead of ['9'] causes
      // all checkboxes to be marked checked on drawer reopen (else branch in setElementValue)
      ...(filter.valueAsArray ? { valueAsArray: true } : {}),
    },
    label: field.filtersLabel,
  })),
});
